var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-filter"},[_c('i-input',{ref:"input",attrs:{"placeholder":_vm.label,"value":_vm.value},on:{"on-change":_vm.changeHandler,"on-focus":function($event){return $event.target.select()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }